import script from "./statusPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./statusPopup.vue?vue&type=script&setup=true&lang=ts"

import "./statusPopup.vue?vue&type=style&index=0&id=6ccd27bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ccd27bf"]])

export default __exports__